import api from './api';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://qm.fwcc.africa/api/v1';

// 1. Interceptor (Ensures token is sent with every 'api' call)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

/* ========================================
   API METHODS
   ======================================== */

// Public endpoint for registration (no auth)
export const getAdminUnitsPublic = async (params) => {
  const response = await api.get('/admin-units/public', { params });
  return response.data;
};

// src/services/adminUnits.js
export const getAdminUnits = async (params) => {
  const response = await api.get('/admin-units', { params });
  return response.data;
};

export const getAdminUnitTree = async () => {
  const response = await api.get('/admin-units/tree');
  return response.data;
};

export const getAdminUnitById = async (id) => {
  const response = await api.get(`/admin-units/${id}`);
  return response.data;
};

// ALIAS for Register.jsx
export const getOrganizationById = async (id) => {
  // If your backend uses /organizations/:id, change the URL below
  const response = await api.get(`/admin-units/${id}`); 
  return response.data;
};

export const createAdminUnit = async (unitData) => {
  const payload = { ...unitData };
  if (!payload.parentId || payload.parentId === "") {
    delete payload.parentId; 
  }
  
  // FIXED: Changed 'axios' to 'api' so the token is actually sent!
  const response = await api.post('/admin-units', payload);
  return response.data;
};

export const updateAdminUnit = async (id, data) => {
  const response = await api.put(`/admin-units/${id}`, data);
  return response.data;
};

export const deleteAdminUnit = async (id) => {
  const response = await api.delete(`/admin-units/${id}`);
  return response.data;
};